// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Analytics20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Analytics20: FC<Analytics20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M4.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 3 15.5V3h1.5v12.5H17V17H4.5Zm1-2.5v-7h3v7h-3Zm4 0V4h3v10.5h-3Zm4 0v-4h3v4h-3Z" />
        </svg>
    );
};

export default Analytics20;
